<template>
  <DialogTemplateToolkit
    v-if="accessStates.includes(tender.tenderStatus.id)"
    :data-qa="'modal-additional-attachment-' + (modal ? 'open' : 'close')"
    :dialog="modal"
    :title="dialogTitle"
    without_first_btn
    without_second_btn
    @close="close()">
    <template v-slot:activator-btn>
      <MenuItem
        class="h11-links"
        data-qa="menu-item-open-additional-attachment"
        icon="folders"
        :label="btnLabel"
        @click="open"/>
    </template>
    <template v-slot:card-text>
      <div
        class="width-100 main__light_green text-start">
        <div
          v-if="success"
          class="font-size-16"
          style="line-height: 20px;">
          {{ successText }}
        </div>
        <ImportBlock
          v-else
          :create-file-handler="createFileHandler"
          :disabled="loading"
          :files.sync="files"
          files-types/>
      </div>
    </template>
    <template v-slot:first_btn>
      <sButton
        class="mr-4"
        data-qa="modal-additional-attachment-btn-add"
        :disabled="!success && (loading || !files.length)"
        @click="success ? close() : sendDocuments()">
        {{ success ? $t('Common.GoToFiles') : $t('Common.Add') }}
      </sButton>
    </template>
    <template v-slot:second_btn>
      <sButton
        v-if="!success"
        data-qa="modal-additional-attachment-btn-cancel"
        type="text"
        @click="close()">
        {{ $t('Common.Close') }}
      </sButton>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { tenderMixin } from 'mixins'
import { AdditionalDocumentFile, ExternalDocumentFile } from '@/types/commonFile.js'

/**
 * Диалог загрузки доп. документов в тендер
 * пункт меню "Додати внутрішні документи"
 * @vue-data {Boolean} modal - Признак отображения окна загрузки файлов
 * @vue-data {Boolean} loading - Индикатор процесса загрузки файлов
 * @vue-data {Boolean} success - Файлы успешно загружены
 * @vue-data {Array} files - Файлы для загрузки
 */
export default {
  name: 'additionalAttachmentsToTender',
  mixins: [ tenderMixin ],
  data() {
    return {
      modal: false,
      loading: false,
      success: false,
      files: [],
    }
  },
  methods: {
    open() {
      setTimeout(() => {
        this.modal = true
        this.$emit('open')
      }, 100)
    },
    close() {
      this.modal = false
      if (this.success) {
        this.$root.$emit('tenderUpdate', true)
        this.files = []
        this.success = false
      }
    },
    createFileHandler(file) {
      if (this.typeDocument === 'inner') {
        return new AdditionalDocumentFile(this.tender.tenderId, null, null, file)
      }
      return new ExternalDocumentFile(this.tender.tenderId, null, null, file)
    },
    /**
     * Загружаем документы в тендер
     */
    sendDocuments() {
      if (!this.files.length) { return }
      this.loading = true

      const uploadDocument = this.typeDocument === 'inner' ? this.uploadAdditionalDocument : this.uploadPublicTenderResultDocument
      uploadDocument(this.files)
        .finally(() =>  {
          this.loading = false
          this.success = true
        })
    }
  },
  computed: {
    accessStates() {
      return [this.statuseKeys.BID_ANALYSIS, this.statuseKeys.COMPLETED, this.statuseKeys.PURCHASE_NOT_PLACED, this.statuseKeys.CANCELED]
    },
    dialogTitle() {
      if (this.success) {
        return this.$t('Common.DocumentsAddedSuccessfully')
      }
      return this.btnLabel
    },
    btnLabel() {
      return this.typeDocument === 'inner' ? this.$t('Common.AddInternalDocuments') : this.$t('Common.AddExternalDocuments')
    },
    successText() {
      return this.typeDocument === 'inner' ? this.$t('Common.AddInternalDocumentsSuccess') : this.$t('Common.AddExternalDocumentsSuccess')
    },

  },
  props: {
    /** Тендер в который нужно загружать файлы */
    tender: {
      type: Object,
      require: true
    },
    typeDocument: {
      type: String,
      validator: function (value) {
        const correct = ['inner', 'external'].indexOf(value) !== -1
        return correct
      },
      default: 'inner',
    }
  },
  components: {
    MenuItem,
    ImportBlock,
    DialogTemplateToolkit
  }
}
</script>
